class DetailsPopover extends DetailsDisclosure {
  constructor() {
    super();
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.querySelectorAll('[data-param]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const params = new URLSearchParams(window.location.search);
        params.set(link.dataset.param, link.dataset.value);
        window.location.search = params.toString();
      });
    });
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
  }

  static closeAll() {
    document.querySelectorAll('details-popover').forEach((popover) => popover.close());
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.summary.classList.toggle('btn--active', isOpen);
    this.summary.setAttribute('aria-expanded', isOpen);

    if (!isOpen) return;

    document.querySelectorAll('details-popover').forEach((popover) => {
      if (popover !== this) popover.close();
    });
    document.dispatchEvent(new CustomEvent('details-popover:open'));
  }

  onDocumentClick(event) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    if (this.contains(event.target)) return;
    this.close();
  }

  onKeyDown(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.close();
  }

  close() {
    super.close();
    this.summary.classList.remove('btn--active');
  }
}

customElements.define('details-popover', DetailsPopover);
